import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";

import { BackInStockStateModule } from "@hermes/states/back-in-stock";

import { CallToActionNotifyMeComponent } from "./call-to-action-notify-me.component";

@NgModule({
    imports: [CommonModule, CallToActionComponent, BackInStockStateModule],
    declarations: [CallToActionNotifyMeComponent],
    exports: [CallToActionNotifyMeComponent],
})
export class CallToActionNotifyMeModule {}
